import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { TimetableSlotSelectionEvent } from '@dreryk/react-calendar';
import { ButtonVariant, ModalConfirmButton } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

import { AppointmentPatientBookAction } from './AppointmentPatientBookModal.actions';
import { AppointmentCreateModal } from './shared/AppointmentCreateModal';
import { AppointmentCreateActionEventInterceptor } from './interceptors/AppointmentCreateActionEventInterceptor';

type AppointmentPatientBookModalProps = {
   readonly selectedSlot: TimetableSlotSelectionEvent<AppointmentPractitioner>;
   readonly overlappingAppointmentsAllowed: boolean;
   readonly onClose: VoidFunction;
   readonly onSuccess: VoidFunction;
   readonly selectedPatient: PatientSimple;
};

export const AppointmentPatientBookModal = (props: AppointmentPatientBookModalProps): JSX.Element => {
   return (
      <AppointmentCreateModal
         testId={'appointmentPatientBook'}
         selectedSlot={props.selectedSlot}
         overlappingAppointmentsAllowed={props.overlappingAppointmentsAllowed}
         onClose={props.onClose}
         selectedPatient={props.selectedPatient}
         confirmButton={({ handleSubmit, setAppointmentTimeSlotOccupiedError }) => (
            <>
               <AppointmentCreateActionEventInterceptor
                  handleSubmit={handleSubmit}
                  onAppointmentTimeSlotOccupiedFault={setAppointmentTimeSlotOccupiedError}
               >
                  <ModalConfirmButton
                     label={appointmentsTranslationKeys.create.modal.confirm.register}
                     onClick={props.onSuccess}
                     variant={ButtonVariant.SECONDARY}
                     testId={'createAppointment'}
                  />
               </AppointmentCreateActionEventInterceptor>
               <AppointmentPatientBookAction
                  handleSubmit={handleSubmit}
                  onAppointmentTimeSlotOccupiedFault={setAppointmentTimeSlotOccupiedError}
               >
                  {({ label }) => (
                     <ModalConfirmButton
                        label={label}
                        onClick={props.onSuccess}
                        testId={'createAppointmentAndGoBack'}
                     />
                  )}
               </AppointmentPatientBookAction>
            </>
         )}
      />
   );
};
